import {CollectionType} from 'types/recommedation-types/recommendations';

import {ProductModel} from './types';

export const formatShopifyId = (shopifyId: string): string => {
  return shopifyId.replace('gid://shopify/Product/', '');
};

export const getProPointPromotions = (product: ProductModel, isThai?: boolean) => {
  const proPointPromotions =
    product.collections
      ?.filter(
        (collection) =>
          collection?.type === CollectionType.PROPOINT_PROMOTION &&
          collection.promotion?.conditionDetail &&
          collection.promotion.conditionDetail.targetValue > 0 &&
          collection.promotion.conditionDetail.rewardValue > 0
      )
      .map((proPoint) => proPoint.promotion.conditionDetail) ?? [];
  const totalPromotions = product.collections?.reduce((count, collection) => {
    if (collection.type === 'PROPOINT_PROMOTION') {
      return count + 1;
    }

    if (collection.type === 'PROMOTION') {
      const title = (isThai ? collection.titleAlt : collection.title) as string;
      return title.toLocaleLowerCase().includes('point') ? count + 1 : count;
    }
    return count;
  }, 0);
  const totalProPointPromotions = proPointPromotions?.length;
  const [firstPromotion] = proPointPromotions;

  const proPointPromotionsApplicable = totalProPointPromotions && firstPromotion;

  if (proPointPromotionsApplicable) {
    return {
      totalPromotions,
      totalProPointPromotions,
      proPointPromotionsApplicable,
      promotionSuggestion: firstPromotion
    };
  }

  return {
    totalPromotions,
    totalProPointPromotions,
    proPointPromotionsApplicable,
    promotionSuggestion: {
      targetValue: 0,
      rewardValue: 0
    }
  };
};
